/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Grade_Adjusted_Pace_One_LinerInputs */

const en_exp_grade_adjusted_pace_one_liner = /** @type {(inputs: Exp_Grade_Adjusted_Pace_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your pace as if the route were flat — climbs and descents get evened out.`)
};

const de_exp_grade_adjusted_pace_one_liner = /** @type {(inputs: Exp_Grade_Adjusted_Pace_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Tempo, als wäre die Strecke flach — Anstiege und Gefälle werden ausgeglichen.`)
};

/**
* | output |
* | --- |
* | "Your pace as if the route were flat — climbs and descents get evened out." |
*
* @param {Exp_Grade_Adjusted_Pace_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_grade_adjusted_pace_one_liner = /** @type {((inputs?: Exp_Grade_Adjusted_Pace_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Grade_Adjusted_Pace_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_grade_adjusted_pace_one_liner(inputs)
	return de_exp_grade_adjusted_pace_one_liner(inputs)
});